/** "1 row", "2 rows": a count with its noun, plural by a plain `s`. */
export function pluralCount(count: number, noun: string): string {
  return `${count} ${noun}${count === 1 ? "" : "s"}`;
}
